import React, {FC} from 'react';
import TimeSlotPicker, {TPStyle} from 'components/TimePicker';
import {Callbacks} from 'components/TimePicker/reducer';
import {Location} from 'components/TimePicker/types';
import {Routes} from 'constants/index';
import {Link} from 'gatsby';

import * as styles from './styles.module.scss';

type LocationSlotsProps = {
	location: Location
	initial?: string
	loading: boolean
	callbacks: Callbacks
}

const LocationSlots: FC<LocationSlotsProps> = ({
	location,
	initial,
	loading,
	callbacks,
}) => {
	return (
		<div className={styles.slots}>
			<div className={styles.title}>
				Choose a time that works for you:
			</div>

			<TimeSlotPicker
				dateSlots={location.datesBase}
				style={TPStyle.sectioned}
				initial={initial}
				loading={loading}
				callbacks={callbacks}
			/>

			{location.datesBase.length === 0 && (
				<div className={styles.empty}>
					<p>
						There are no time slots currently
						available. <Link to={Routes.booking}>Click
						here</Link> to find another location nearby
						or contact support at 310-601-8184.
					</p>
				</div>
			)}
		</div>
	);
};

export default LocationSlots;
